// extracted by mini-css-extract-plugin
export default {"isActive":"cardSummary_isActive__BRZlm"};